.segmentedControl {
  & :global(.rt-SegmentedControlItemSeparator) {
    display: none;
  }

  & :global(.rt-SegmentedControlIndicator)::before {
    border-radius: 8px;
    background-color: var(--fly-color-scheme-gray-0);
  }
}
